<template>
  <div class="medal-popup">
    <van-popup
      v-model="innerVisible"
      :close-on-click-overlay="false"
      round
    >
      <div class="popup-body">
        <img src="@/assets/images/training/img(61).png" class="medal-img" alt="">
        <div class="wrap-txt2">
          <div class="txt">限定徽章</div>
        </div>
        <img src="@/assets/images/training/img(46).png" @click="handleClose" class="medal-close-icon" alt="">
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'MedalPopup',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerVisible: this.value
    }
  },
  watch: {
    value(val) {
      this.innerVisible = val
    },
    innerVisible(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    handleClose() {
      this.$emit('input', false)
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.medal-popup {
  /deep/ .van-popup {
    background-color: transparent;
    overflow-y: visible;
    z-index: 1000 !important;
  }

  .popup-body {
    width: 280px;
    height: 420px;
    position: relative;

    .medal-img {
      width: 280px;
      height: 420px;
      display: block;
    }

    .medal-close-icon {
      width: 32px;
      height: 32px;
      position: absolute;
      bottom: -48px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

.wrap-txt2 {
  text-align: center;
  color: #000000;
  font-size: 22px;
  line-height: 32px;
  font-weight: 500;
  font-family: Source Han Sans CN, Source Han Sans CN;
  position: absolute;
  top: 343px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;

  .txt {
    display: block;
    flex: 1;
    line-height: 28px;
    font-size: 22px;
    color: #000;
  }
}
/deep/ .van-overlay {
  z-index: 1000 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/MedalPopup.vue